import { TerminalClosurePaymentMethodSummary } from "@towersystems/roam-common/lib/generated-types";
import { Divider } from "@towersystems/roam-common-native";
import { FlatList } from "react-native";
import { useCallback } from "react";
import { View } from "react-native-ui-lib";
import { Text } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "../../../../utilities/money";
export interface CountedPaymentListProps {
  payments: TerminalClosurePaymentMethodSummary[];
}

export const CountedPaymentList = ({ payments }: CountedPaymentListProps) => {
  const renderItem = useCallback(
    ({ item }: { item: TerminalClosurePaymentMethodSummary }) => {
      return (
        <View row>
          <View flex>
            <Text variant="heading1">{item.paymentTypeName}</Text>
          </View>
          <View
            style={{ justifyContent: "flex-end", alignContent: "flex-end" }}
          >
            <Text variant="heading1" style={{ textAlign: "right" }}>
              Amount counted: {moneyToFormattedString(item.total)}
            </Text>
            {item.payTypeId === "1" && item.difference !== 0 && (
              <Text
                variant="heading2"
                color="subdued"
                style={{ textAlign: "right" }}
              >
                Difference: {moneyToFormattedString(item.difference)}
              </Text>
            )}
          </View>
        </View>
      );
    },
    []
  );

  return (
    <FlatList
      scrollEnabled={false}
      ItemSeparatorComponent={Divider}
      data={payments}
      renderItem={renderItem}
    ></FlatList>
  );
};
